import React from "react";
import Button from "../../../UI/Button/Button";
import WhiteUpRightArrow from "../../../../icons/arrows/white-upright-arrow.svg";
import * as styles from "./Header.module.scss";

const Header = ({ name = "Nombre", model = "Modelo", link, colorCategory }) => {
  const onBuy = () => {
    window.open(link, "_blank");
  };

  return (
    <div className={`${styles.productHeader}`}>
      <div className="container justify-between align-center">
        <div className={`${styles.productHeader__title}`}>
          <div className={styles.title}>
            <h6>{name}</h6>
          </div>
          <div className={styles.product_code}>
            <p className={styles.model}>{model}</p>
          </div>
        </div>
        <div className={styles.ml_button}>
          {link && (
            <Button
              text="Comprar"
              icon={WhiteUpRightArrow}
              color={colorCategory}
              onClick={onBuy}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
